/**
 * True for a visit that came from a "Powered by Workspace369" credit on a
 * client-facing page, email or receipt (utm_source=powered_by). The homepage
 * shows those visitors the referral strip (components/PoweredByReferralStrip.vue).
 */
export function isPoweredByVisit(search: string): boolean {
  return new URLSearchParams(search.replace(/^\?/, '')).get('utm_source') === 'powered_by';
}

/** Class set on <html> for a powered_by visit; CSS shows the strip only under it. */
export const POWERED_BY_HTML_CLASS = 'w369-powered-by';

/**
 * Inline <head> script: the homepage is prerendered, so the query is only known
 * in the browser. Deciding before first paint (not in onMounted) means the
 * strip is there from the first frame and the hero never jumps. Same rule as
 * isPoweredByVisit; tests/tracking/poweredBy.test.ts runs both on the same URLs.
 */
export const POWERED_BY_HEAD_SCRIPT =
  `try{if(new URLSearchParams(location.search).get('utm_source')==='powered_by')document.documentElement.classList.add('${POWERED_BY_HTML_CLASS}')}catch(e){}`;
